<template>
  <div class="hello">
    <h1 v-bind:class="{ doNotDisplay: hideForm }">{{ msg }}</h1>
    <div class="container" v-bind:class="{ doNotDisplay: hideLoading }">
      <section>
      <div class="columns is-gapless is-mobile">
        <div class="column">
        </div>
        <div class="column is-one-quarter">
          <div class="half-circle-spinner" style="margin: 50px auto">
            <div class="circle circle-1"></div>
            <div class="circle circle-2"></div>
          </div>
        </div>
        <div class="column">
        </div>
      </div>
      </section>
    </div>
    <div class="container" v-bind:class="{ doNotDisplay: hideSuccess }">
      <section>
        <div class="columns is-gapless is-mobile">
          <div class="column">
          </div>
          <div class="column is-one-quarter">
            <div class="check_mark" style="margin: 50px auto">
              <div class="sa-icon sa-success animate" v-bind:class="{ hide: hideSuccess }">
                <span class="sa-line sa-tip animateSuccessTip"></span>
                <span class="sa-line sa-long animateSuccessLong"></span>
                <div class="sa-placeholder"></div>
                <div class="sa-fix"></div>
              </div>
            </div>
          </div>
          <div class="column">
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <h1>Vi har mottatt din oppsigelse på Dagbladet Pluss, den vil bli behandlet innen 48 timer</h1>
          </div>
        </div>
      </section>
    </div>
    <div class="container" v-bind:class="{ doNotDisplay: hideForm }">
      <section>
        <div class="columns">
          <b-field label="Fornavn" for="fname" class="column is-half-desktop"
               v-bind:type="{ 'is-danger': $v.form.name.$error }"
               v-bind:message="[
                  { 'Fornavn må være minst 2 bokstaver langt': !$v.form.name.minLength },
                  { 'Fornavn kan ikke være lenger enn 191 bokstaver': !$v.form.name.maxLength},
                  { 'Vennligst skriv inn ditt fornavn': !$v.form.name.required && $v.form.name.$error}
            ]">
            <b-input v-model.trim:value="$v.form.name.$model"  type="text" name="fname" autocomplete="given-name" placeholder="Ola"></b-input>
          </b-field>

          <b-field label="Etternavn" for="lname" class="column is-half-desktop"
               v-bind:type="{ 'is-danger': $v.form.lastName.$error }"
               v-bind:message="[
                  { 'Etternavn må være lengre enn 2 bokstaver': !$v.form.lastName.minLength },
                  { 'Etternavn kan ikke være lenger enn 191 bokstaver': !$v.form.lastName.maxLength},
                  { 'Vennligst skriv inn ditt etternavn': !$v.form.lastName.required && $v.form.lastName.$error}
            ]">
            <b-input v-model.trim:value="$v.form.lastName.$model" type="text" name="lname" autocomplete="family-name" placeholder="Nordmann"></b-input>
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Adresse" class="column is-one-third-desktop"
               v-bind:type="{ 'is-danger': $v.form.address.$error }"
               v-bind:message="[
                  { 'Adresse må være lengre enn 2 bokstaver': !$v.form.address.minLength },
                  { 'Adresse kan ikke være lenger enn 191 bokstaver': !$v.form.address.maxLength},
                  { 'Vennligst skriv inn din adresse': !$v.form.address.required && $v.form.address.$error}
            ]">
            <b-input v-model.trim:value="$v.form.address.$model" autocomplete="address-line1" placeholder="Karvesvingen 1"></b-input>
          </b-field>

          <b-field label="Postnummer" class="column is-one-third-desktop"
               v-bind:type="{ 'is-danger': $v.form.zip.$error }"
               v-bind:message="[
                  { 'Postnummer må har bare sifre og/eller bokstaverk': !$v.form.zip.alphaNum },
                  { 'Postnummer må være lengre enn 2 symbol': !$v.form.zip.minLength },
                  { 'Postnummer kan ikke være lenger enn 191 symbol': !$v.form.zip.maxLength},
                  { 'Vennligst skriv inn din postkode': !$v.form.zip.required && $v.form.name.$error}
            ]">
            <b-input v-model.trim:value="$v.form.zip.$model" name="zip" type="text"  autocomplete="postal-code" pattern="[0-9]*" aria-label="Postal code" placeholder="0579"></b-input>
          </b-field>

          <b-field label="Poststed" class="column is-one-third-desktop"
               v-bind:type="{ 'is-danger': $v.form.city.$error }"
               v-bind:message="[
                  { 'Poststed må være minst 1 bokstav': !$v.form.city.minLength },
                  { 'Poststed kan ikke være lenger enn 191 bokstaver': !$v.form.city.maxLength},
                  { 'Vennligst skriv inn ditt poststed': !$v.form.city.required && $v.form.city.$error}
            ]">
            <b-input v-model.trim:value="$v.form.city.$model" aria-label="City" autocomplete="address-level2" placeholder="Oslo"></b-input>
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Land" class="column"
               v-bind:type="{ 'is-danger': $v.form.country.$error }"
               v-bind:message="[
                  { 'Land kan ikke være lenger enn 191 bokstaver': !$v.form.country.maxLength},
                  { 'Vennligst velg ditt land': !$v.form.country.required && $v.form.country.$error}
            ]">
            <b-select v-model.trim:value="$v.form.country.$model" expanded autocomplete="country" name="country" placeholder="Norge">
              <option v-for="country in countries" aria-label="Country" v-bind:key="country.countryCode" v-bind:value="country.countryCode">{{country.name}} {{country.emoji}}</option>
            </b-select>
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Telefonnummer" class="column is-half-desktop"
               v-bind:type="{ 'is-danger': $v.form.phoneNo.$error || $v.form.phoneNoCountryCode.$error }"
               v-bind:message="[
                  { 'Landskode kreves': !$v.form.phoneNoCountryCode.required && $v.form.phoneNoCountryCode.$error},
                  { 'Telefonnummer kan kun bestå av tall': !$v.form.phoneNo.numeric },
                  { 'Vennligst skriv inn et gyldig telefonnummer': !$v.form.phoneNo.phoneNoValid  && $v.form.phoneNo.$error},
                  { 'Telefonnummer har for få sifre': !$v.form.phoneNo.required && $v.form.phoneNo.$error}
            ]">
            <b-select v-model="$v.form.phoneNoCountryCode.$model" autocomplete="tel-country-code" placeholder="+47" type="text">
              <option v-for="countryPhoneCode in countryPhoneCodes" v-bind:key="countryPhoneCode" v-bind:value="countryPhoneCode">{{countryPhoneCode}}</option>
            </b-select>
            <b-input v-model.trim:value="$v.form.phoneNo.$model" autocomplete="tel-national" placeholder="12345678" expanded></b-input>
          </b-field>

          <b-field label="E-postadresse" class="column is-half-desktop"
               v-bind:type="{ 'is-danger': $v.form.eMail.$error }"
               v-bind:message="[
                  { 'Vennligst skriv inn en gyldig e-postadresse': !$v.form.eMail.email && $v.form.eMail.$error},
                  { 'E-postadresse kan ikke være lenger enn 191 bokstaver': !$v.form.eMail.maxLength},
                  { 'Vennligst skriv inn din e-postadresse': !$v.form.eMail.required && $v.form.eMail.$error}
            ]">
            <b-input type="text" v-model.trim:value="$v.form.eMail.$model" autocomplete="email" aria-label="e-Mail" placeholder="ola.nordmann@example.com">
            </b-input>
          </b-field>
        </div>

        <div class="columns">
          <b-button type="is-success" :disabled="!allFieldsAreFilled || $v.form.$invalid"
                  @click="submit" style="margin: 0.75rem;">Send Inn
          </b-button>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
import { submitForm } from './API/api.js'
import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js/max'
import { required, minLength, email, numeric, alphaNum, maxLength, helpers } from 'vuelidate/lib/validators'
const phoneNumberIsValid = (param) =>
  (value) => {
    if (!helpers.req(param)) {
      return false
    }
    const phoneNumber = parsePhoneNumberFromString(param + value)
    if (phoneNumber) {
      return phoneNumber.isValid()
    }
    return false
  }

export default {
  name: 'DagbladetForm',
  props: {
    msg: String
  },
  data () {
    const countries = Object.entries(this.$countries.countries).map((value) => {
      value[1].countryCode = value[0]
      return value[1]
    }).sort((a, b) => (a.name > b.name) ? 1 : -1)
    const allCountryPhoneCodes = getCountries().map(countryCode => getCountryCallingCode(countryCode))
    const noDuplicatesSortedCountryPhoneCodes = [...new Set(allCountryPhoneCodes.sort((a, b) => { return a - b }).map(code => '+' + code))]

    return {
      form: {
        name: '',
        lastName: '',
        address: '',
        zip: '',
        city: '',
        country: 'NO',
        phoneNoCountryCode: '+47',
        phoneNo: '',
        eMail: ''
      },
      countryPhoneCodes: noDuplicatesSortedCountryPhoneCodes,
      countries: countries,
      path: 'https://lg62tb0256.execute-api.eu-west-1.amazonaws.com/form-submit',
      hideSuccess: true,
      hideLoading: true,
      hideForm: false
    }
  },
  validations () {
    return {
      form: {
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(191)
        },
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(191)
        },
        address: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(191)
        },
        zip: {
          required,
          alphaNum,
          minLength: minLength(2),
          maxLength: maxLength(191)
        },
        city: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(191)
        },
        country: {
          required,
          maxLength: maxLength(191)
        },
        phoneNoCountryCode: {
          required
        },
        phoneNo: {
          required,
          numeric,
          phoneNoValid: phoneNumberIsValid(this.form.phoneNoCountryCode)
        },
        eMail: {
          required,
          email,
          maxLength: maxLength(191)
        }
      }
    }
  },
  methods: {
    submit () {
      const dataToSubmit = { ...this.form }
      dataToSubmit.phoneNo = dataToSubmit.phoneNoCountryCode + dataToSubmit.phoneNo

      if (!this.$v.form.$invalid) {
        this.hideForm = true
        this.hideLoading = false
        submitForm(dataToSubmit, this.path, () => {
          this.hideLoading = true
          this.hideSuccess = false
        })
        this.$v.$reset()
        this.form = {
          name: '',
          lastName: '',
          address: '',
          zip: '',
          city: '',
          country: 'NO',
          phoneNoCountryCode: '+47',
          phoneNo: '',
          eMail: ''
        }
      }
    }
  },
  computed: {
    allFieldsAreFilled () {
      let formDataValid = true
      Object.keys(this.form).forEach(key => {
        if (this.form[key] === null || this.form[key] === undefined || ''.localeCompare(this.form[key]) === 0) {
          formDataValid = false
        }
      })
      return formDataValid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1,h2 {
    font-size: 1.5rem;
  }

  .container{
    margin: 5rem auto;
  }

  .half-circle-spinner, .half-circle-spinner * {
    box-sizing: border-box;
  }

  .half-circle-spinner {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    position: relative;
  }

  .half-circle-spinner .circle {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: calc(40px / 10) solid transparent;
  }

  .half-circle-spinner .circle.circle-1 {
    border-top-color: rgba(76, 175, 80, .5);
    animation: half-circle-spinner-animation 1s infinite;
  }

  .half-circle-spinner .circle.circle-2 {
    border-bottom-color: rgba(76, 175, 80, .5);
    animation: half-circle-spinner-animation 1s infinite alternate;
  }

  @keyframes half-circle-spinner-animation {
    0% {
      transform: rotate(0deg);

    }
    100%{
      transform: rotate(360deg);
    }
  }

  /*Success animation*/
  .check_mark {
    width: 80px;
    height: 130px;
    margin: 0 auto;
  }

  button {
    cursor: pointer;
    margin-left: 15px;
  }

  .hide{
    display:none;
  }

  .sa-icon {
    width: 80px;
    height: 80px;
    border: 4px solid gray;
    -webkit-border-radius: 40px;
    border-radius: 40px;
    border-radius: 50%;
    margin: 20px auto;
    padding: 0;
    position: relative;
    box-sizing: content-box;
  }

  .sa-icon.sa-success {
    border-color: #4CAF50;
  }

  .sa-icon.sa-success::before, .sa-icon.sa-success::after {
    content: '';
    -webkit-border-radius: 40px;
    border-radius: 40px;
    border-radius: 50%;
    position: absolute;
    width: 60px;
    height: 120px;
    background: white;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .sa-icon.sa-success::before {
    -webkit-border-radius: 120px 0 0 120px;
    border-radius: 120px 0 0 120px;
    top: -7px;
    left: -33px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 60px 60px;
    transform-origin: 60px 60px;
  }

  .sa-icon.sa-success::after {
    -webkit-border-radius: 0 120px 120px 0;
    border-radius: 0 120px 120px 0;
    top: -11px;
    left: 30px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 0px 60px;
    transform-origin: 0px 60px;
  }

  .sa-icon.sa-success .sa-placeholder {
    width: 80px;
    height: 80px;
    border: 4px solid rgba(76, 175, 80, .5);
    -webkit-border-radius: 40px;
    border-radius: 40px;
    border-radius: 50%;
    box-sizing: content-box;
    position: absolute;
    left: -4px;
    top: -4px;
    z-index: 2;
  }

  .sa-icon.sa-success .sa-fix {
    width: 5px;
    height: 90px;
    background-color: white;
    position: absolute;
    left: 28px;
    top: 8px;
    z-index: 1;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .sa-icon.sa-success.animate::after {
    -webkit-animation: rotatePlaceholder 4.25s ease-in;
    animation: rotatePlaceholder 4.25s ease-in;
  }

  .sa-icon.sa-success {
    border-color: transparent\9;
  }
  .sa-icon.sa-success .sa-line.sa-tip {
    -ms-transform: rotate(45deg) \9;
  }
  .sa-icon.sa-success .sa-line.sa-long {
    -ms-transform: rotate(-45deg) \9;
  }

  .animateSuccessTip {
    -webkit-animation: animateSuccessTip 0.75s;
    animation: animateSuccessTip 0.75s;
  }

  .animateSuccessLong {
    -webkit-animation: animateSuccessLong 0.75s;
    animation: animateSuccessLong 0.75s;
  }

  @-webkit-keyframes animateSuccessLong {
    0% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    65% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    84% {
      width: 55px;
      right: 0px;
      top: 35px;
    }
    100% {
      width: 47px;
      right: 8px;
      top: 38px;
    }
  }
  @-webkit-keyframes animateSuccessTip {
    0% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    54% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    70% {
      width: 50px;
      left: -8px;
      top: 37px;
    }
    84% {
      width: 17px;
      left: 21px;
      top: 48px;
    }
    100% {
      width: 25px;
      left: 14px;
      top: 45px;
    }
  }
  @keyframes animateSuccessTip {
    0% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    54% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    70% {
      width: 50px;
      left: -8px;
      top: 37px;
    }
    84% {
      width: 17px;
      left: 21px;
      top: 48px;
    }
    100% {
      width: 25px;
      left: 14px;
      top: 45px;
    }
  }

  @keyframes animateSuccessLong {
    0% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    65% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    84% {
      width: 55px;
      right: 0px;
      top: 35px;
    }
    100% {
      width: 47px;
      right: 8px;
      top: 38px;
    }
  }

  .sa-icon.sa-success .sa-line {
    height: 5px;
    background-color: #4CAF50;
    display: block;
    border-radius: 2px;
    position: absolute;
    z-index: 2;
  }

  .sa-icon.sa-success .sa-line.sa-tip {
    width: 25px;
    left: 14px;
    top: 46px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .sa-icon.sa-success .sa-line.sa-long {
    width: 47px;
    right: 8px;
    top: 38px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  @-webkit-keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }
  @keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }

  .doNotDisplay {
    display: none;
  }
</style>
